import React from 'react';

import { Field } from 'formik';

import DatePickerField from 'CommonComponents/DatePickerField';
import Slider from 'CommonComponents/slider/Slider';

export default function MilestoneRow({ values, errors, touched, setFieldValue, minDate, maxDate, section, index, actions }) {
    return (
        <div className="tw-grid tw-grid-cols-12 tw-gap-x-4 tw-w-full tw-p-4 tw-bg-white tw-border tw-border-gray-200 tw-rounded-lg tw-shadow dark:tw-bg-gray-800 dark:tw-border-gray-700">
            <div className="tw-col-span-3 tw-flex tw-items-center tw-gap-x-2">
                <label className="text-input__label tw-block">{$t('Date')}:</label>
                <div className="tw-flex tw-flex-col tw-gap-y-1.5 tw-w-full">
                    <DatePickerField
                        name={`dates.${index}.date`}
                        valueFormat="yyyy-MM-dd"
                        dateFormat="yyyy-MM-dd"
                        className={
                            errors?.date && touched?.date
                                ? `tw-border tw-border-red-500 text-input tmpl-input-${section}`
                                : `tw-border-0 text-input tmpl-input-${section}`
                        }
                        value={values?.dates[index]?.date}
                        onChange={setFieldValue}
                        min={minDate}
                        max={maxDate}
                    />
                    {errors?.date && touched?.date && <div className="tw-text-red-500 tw-text-sm">{errors?.date}</div>}
                </div>
            </div>
            <div className="tw-col-span-3 tw-flex tw-items-center tw-gap-x-2">
                <label className="text-input__label tw-block">{$t('Name')}:</label>
                <div className="tw-flex tw-flex-col tw-gap-y-1.5 tw-w-full">
                    <Field
                        type="text"
                        className={errors?.name && touched?.name ? 'tw-border tw-border-red-500 text-input' : 'tw-border-0 text-input'}
                        name={`dates.${index}.name`}
                    />
                    {errors?.name && touched?.name && <div className="tw-text-red-500 tw-text-sm">{errors?.name}</div>}
                </div>
            </div>
            <div className="tw-col-span-6 tw-flex tw-items-center tw-gap-x-2">
                <label className="text-input__label tw-block">{$t('Percentage')}:</label>
                <div className="tw-flex tw-flex-col tw-gap-y-1.5 tw-w-full">
                    <Slider
                        key={values?.dates[index]?.uniqueKey}
                        index={index}
                        defaultValue={values?.dates[index]?.perc}
                        max={values?.dates[index]?.maxPercentage}
                        setFieldValue={setFieldValue}
                        name={`dates.${index}.perc`}
                    ></Slider>
                    {errors?.perc && touched?.perc && <div className="tw-text-red-500 tw-text-sm">{errors?.perc}</div>}
                </div>
                <div className="tw-ml-4 tw-flex tw-items-center tw-justify-end">{actions}</div>
            </div>
        </div>
    );
}
